import type {Locale} from '@myparcel-frontend/i18n';
import {loadLanguageTranslations} from '@myparcel-frontend/i18n';
import {useI18n} from 'vue-i18n';
import {loadZodErrorTranslations} from '../../i18n/i18n';
import useUiSettings from '../useUiSettings';

export default function useChangeLanguage() {
  const {locale} = useI18n();
  const {uiSettings, putUiSettings} = useUiSettings();

  const changeLanguage = async (languageCode: Locale): Promise<void> => {
    await loadLanguageTranslations(languageCode);
    loadZodErrorTranslations();

    locale.value = languageCode;
    localStorage.setItem('language', languageCode);

    await putUiSettings({
      ...uiSettings.value,
      preferred_language: languageCode,
    });
  };

  return {
    changeLanguage,
  };
}
